// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_IAPYs{position:fixed;visibility:hidden;transition-property:visibility;touch-action:pan-y;z-index:900}.container_IAPYs,.scrim_0mTQl{top:0;bottom:0;right:0;left:0}.scrim_0mTQl{transition-property:opacity;transform:translateZ(0);opacity:0;background:rgba(0,0,0,.5)}.content_JfDYb,.scrim_0mTQl{position:absolute}.content_JfDYb{top:0;bottom:0;left:0;width:256px;transition-property:transform;transform:translate3d(-100%,0,0);background-color:#fff}", ""]);
// Exports
exports.locals = {
	"container": "container_IAPYs",
	"scrim": "scrim_0mTQl",
	"content": "content_JfDYb"
};
module.exports = exports;
